import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NotificationService } from '../../../core/services/core.notification.service';

const template = `<div *ngIf="reminders.length" class="alert alert-info" role="alert">
<h4 class="clearfix" style="margin-bottom: 0;">
    <i style="font-size: 24px; margin-right: .5em;" 
        class="pull-left glyphicon glyphicon-exclamation-sign"></i>
    <div class="pull-left truncate-text" style="margin-top: .25em;">
        <span style="font-weight: normal; margin-right: .5em;" 
            translate>This task has one or more reminders:</span>
        <span *ngFor="let reminder of reminders">
            <gf-reminder-badge [reminder]="reminder"></gf-reminder-badge>
        </span>
    </div>
</h4>
</div>`

@Component({
    selector: 'gf-reminders-alert',
    template: template
})
export class RemindersAlertComponent implements OnInit, OnDestroy {

    @Input() section: string;

    @Input() refId: string;

    protected reminders = [];
    private notificationKey = '';
    
    constructor(private notificationService: NotificationService) { }
    
    ngOnInit() {
        this.notificationKey = `reminder-alerts-${ this.section }-${ this.refId }`;
        this.notificationService.subscribe(
            this.notificationKey, 
            'REMINDER-ALERTS-UPDATED', 
            this.updateReminders
        );
    };

    ngOnDestroy(): void {
        this.notificationService.unsubscribe(this.notificationKey);
    }

    updateReminders = (params) => {
        this.reminders = params.reminders
    }
}